import React from "react";

function FoodPhotosItem(props) {

    const {
        id,
        photoName,
        photoEngName,
        photoFraName,
        photoGerName,
        photoDutName,
        alt,
        onClickEdit,
        onClickEditEng,
        onClickEditFra,
        onClickEditGer,
        onClickEditDut,
        onClickDelete
    } = props;

    const language = (key) => {
        switch (key) {
            case "photoName":
                return "Türkçe";
            case "photoEngName":
                return "İngilizce";
            case "photoFraName":
                return "Fransızca";
            case "photoGerName":
                return "Almanca";
            case "photoDutName":
                return "Felemenkçe";
        }
    };

    return (
        <div className="card" style={{ marginTop: "50px" }}>
            <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mt-5">
                    <div className="lesson_name" style={{ marginTop: "100px" }}>
                        <div className="project-block w-100 d-flex align-items-center justify-content-center">
                            <div style={{
                                display: "flex",
                                gap: "2%",
                                width: "98%",
                                justifyContent: photoName && photoEngName && photoFraName && photoGerName && photoDutName ? "center" : "flex-start",
                                paddingLeft: photoName && photoEngName && photoFraName && photoGerName && photoDutName ? "0" : "1%"
                            }}>
                                {["photoName", "photoEngName", "photoFraName", "photoGerName", "photoDutName"].map((key, idx) => {
                                    const name = props[key];
                                    if (!name) return null;
                                    return (
                                        <div key={key} style={{width: "18%", height: "125px", objectFit: "cover"}}>
                                            <img
                                                src={process.env.PUBLIC_URL + `/uploads/analysis_list/thumb_${name}`}
                                                style={{ width: "100%", height: "100%", borderRadius: "8px", objectFit: "cover" }}
                                                alt={alt}
                                            />
                                            <p className="mt-2" style={{fontSize: "15px"}}>{language(key)}</p>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="btn-group mt-4" role="group" aria-label="Basic outlined example">
                        <button type="button" className="btn btn-outline-secondary" onClick={onClickEdit}>
                            <i className="icofont-edit text-success"></i>
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            title="İngilizce Güncelleme"
                            onClick={onClickEditEng}
                        >
                            <img src={process.env.PUBLIC_URL + `/flags/united-kingdom.png`} style={{ width: "15px" }} />
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            title="Fransızca Güncelleme"
                            onClick={onClickEditFra}
                        >
                            <img src={process.env.PUBLIC_URL + `/flags/france.png`} style={{ width: "15px" }} />
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            title="Almanca Güncelleme"
                            onClick={onClickEditGer}
                        >
                            <img src={process.env.PUBLIC_URL + `/flags/germany.png`} style={{ width: "15px" }} />
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            title="Felemenkçe Güncelleme"
                            onClick={onClickEditDut}
                        >
                            <img src={process.env.PUBLIC_URL + `/flags/netherlands.png`} style={{ width: "15px" }} />
                        </button>
                        <button type="button" className="btn btn-outline-secondary" onClick={onClickDelete}>
                            <i className="icofont-ui-delete text-danger"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-start p-3 border-top">
                <div className="text-primary">{"SEO => "}</div>
                <span className="ms-2">{alt}</span>
            </div>
        </div>
    )
}


export default FoodPhotosItem;